<template>
	<div>
		<div class="row justify-content-center align-items-center">
			<div class="col-11 mt-5">
				<data-input label="Bei welchem Kunden holen Sie grade Flaschen ab?"
				            :placeholder="$t('Kundennummer / Name / Adresse')"
				            v-model="filter"
				/>
			</div>
		</div>
		<div v-for="customer in filteredCustomers"
		     :key="customer.id"

		     class="row justify-content-center mt-2"
		     :class="{'bg-primary':value === customer.id,'text-white':value === customer.id}"
		     @click="$emit('input',customer.id)"
		>
			<div class="col-11 mt-2">
				<customer-list-item :customer="customer"/>
			</div>
		</div>
	</div>
</template>

<script>
import CustomerListItem from "./CustomerListItem";
import {mapActions, mapState} from "vuex";
import DataInput from "./DataInput";

export default {
	name: "CustomerList",
	components: {CustomerListItem, DataInput},
	props: {
		customers: {type: Array, default: () => []},
		value: String
	},
	data() {
		return {
			filter: '',
		}
	},
	computed: {
		filterRegex() {
			return this.filter.replace(' ', '.*')
		},
		filteredCustomers() {
			return this.customers.filter(el => el.customer_number.match(this.filterRegex) || el.name.match(this.filterRegex) || el.address.match(this.filterRegex))
		}
	},
}
</script>

<style scoped>

</style>
